import {stTagResetAction} from 'module/StTag/action/StTagAction';
import _ from 'lodash';
import {combineReducers} from 'redux';
import {StTagTO} from 'generated/JavaTO';
import {createReducer} from 'util/redux';
import moment from 'moment';
import {appInitAction} from 'util/ReduxUtil'

const byId = createReducer<{ [cid in string]: StTagTO }>({}, builder => builder
	.addCase(stTagResetAction, (state, {payload}) => {
		const s = _.keyBy(payload, 'id');
		if (!_.isEqual(s, state)) return s;
		return state
	}),
)

const allIds = createReducer<string[]>([], builder => builder
	.addCase(stTagResetAction, (state, {payload}) => {
		const s = _.map(payload, 'id');
		if (!_.isEqual(s, state)) return s;
		return state
	}),
)

const lastRefresh = createReducer<number>(0, builder => builder
	.addCase(appInitAction, () => 0)
	.addCase(stTagResetAction, () => +moment()),
)

export const StTagReducerNS = {StTag: combineReducers({byId, allIds, lastRefresh})};
export type StTagStateType = { StTag: ReturnType<typeof StTagReducerNS.StTag> }